/**
  * @class meleActorRadar
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-radar>` custom web element for showing actual radar status from mmRadar in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  state: { description: 'current state of the radar', type: 'string', readonly: true },
  interupted: { description: 'interupted message of radar', type: 'string', readonly: true },
  tracked: { description: 'number of currently tracked targets', type: 'integer', readonly: true, default: 0 },
}, meleActor._properties)

export default class meleActorRadar extends meleActor {
  init() {
    this.state = 'disconnected'
    this.elTargetDuration = this.appendChildren({ tag: 'mele-input', label: 'radar.duration', readonly: true, key: 'duration', after: 's' })
    this.elTargetSpeed = this.appendChildren({ tag: 'mele-input', label: 'radar.hit_measured', readonly: true, key: 'speed', after: 'km/h' })
    this.elTargetRoute = this.appendChildren({ tag: 'mele-input', label: 'radar.distance', readonly: true, key: 'route', after: 'm' })
    this.elState = this.appendChildren({ tag: 'mele-text', key: 'state' })
    this.classList.add('hidden')
    super.init()
  } // init

  message({ params }) {
    // expected is mmRadarConfig
    this.state = params.state
    this.tracked = params.tracked
    this.interupted = params.interupted
    if(params.tracked>0) {
      const target = params.targets[0]
      this.elTargetDuration.value = (target.duration / 1000).toFixed(1)
      this.elTargetRoute.value = (target.route / 1000).toFixed(1)
      this.elTargetSpeed.value = target.speed
    }else{
      this.elTargetDuration.value = '0'
      this.elTargetRoute.value = '0'
      this.elTargetSpeed.value = '0'
    }
  } // message

  interuptedChanged(value, old) {
    if(value) {
      this.elState.label = 'radar.interupted.'+value
    }
  }

  stateChanged(value, old) {
    this.info('STATE CHANGED', value)
    if(value != 'interupted') {
      this.elState.label = 'radar.state.'+value
    }
    this.elState.hidden = /error/.test(value)

    if(/measuring/.test(value)) {
      this.animateMeasurement(true)
    } else if(/ready/.test(value)) {
      if(this.classList.contains('hidden')) return
      this.animateMeasurement()
    }
  }

  animateSpeedEnlargment(show) {
    const options = {
      duration: 300,
      easing: 'ease-in-out',
    }
    const animationSteps = [
      { transform: `scale(${show ? 1.2 : 1})` },
      { transform: `translateY(${show ? 0 : 4}px)` },
    ]
    const speedAnimation = this.elTargetSpeed.animate(animationSteps, options)
    speedAnimation.onfinish = ()=>{
      if(show) {
        this.elTargetSpeed.classList.add('enlarge')
      } else {
        this.elTargetSpeed.classList.remove('enlarge')
      }
    }
    speedAnimation.play()
  }

  animateMeasurement(show) {
    const options = {
      duration: 300,
      easing: 'ease-in-out',
    }
    const animationSteps = [
      { transform: `translateY(${show ? 0 : -200}px)` },
    ]
    const durationAnimation = this.elTargetDuration.animate(animationSteps, options)
    const speedAnimation = this.elTargetSpeed.animate(animationSteps, options)
    const routeAnimation = this.elTargetRoute.animate(animationSteps, options)
    durationAnimation.onfinish = ()=> {
      if(show) {
        this.classList.remove('hidden')
      } else {
        this.classList.add('hidden')
      }
    }
    durationAnimation.play()
    speedAnimation.play()
    routeAnimation.play()
  }
} // class meleActorRadar

meleActorRadar._properties = PROPERTIES
meleActorRadar.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-radar', meleActorRadar)
